import React from 'react';
import { ModuleProps } from 'types';
import { useLocation } from 'react-router-dom';
import { parseQueryParams } from 'utilities/query-params-util';
import ClassroomLoginCardContainer from 'components/PrintScreenModule/LoginCards/components/ClassroomLoginCardContainer';
import StudentLoginCardContainer from 'components/PrintScreenModule/LoginCards/components/StudentLoginCardContainer';

const LoginCardContainer: React.FC<ModuleProps> = () => {
  const location = useLocation();
  const params = parseQueryParams(location.search);

  return (
    <div>
      {!params?.studentId && params?.classroomId && (
        <ClassroomLoginCardContainer
          classroomId={Number(params?.classroomId)}
          product={`${params?.product}`}
        />
      )}
      {params?.studentId && params.classroomId && (
        <StudentLoginCardContainer
          studentId={Number(params.studentId)}
          classroomId={Number(params.classroomId)}
          product={`${params?.product}`}
        />
      )}
    </div>
  );
};

export default LoginCardContainer;
